import { Component, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SelectionState } from '@alfresco/adf-extensions';
import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { SmtExcelExportAction } from 'projects/alden-extension/src/lib/store/actions/actions';
import { CustomListService } from 'projects/alden-extension/src/lib/services/custom-list.service';

@Component({
  selector: 'smt-action-excel-export',
  templateUrl: './excel-export.component.html'
})
export class ExcelExportComponent implements OnInit {

  selection$: Observable<SelectionState>;

  constructor(private store: Store<AppStore>, private customListService: CustomListService) {}

  ngOnInit() {
    this.selection$ = this.store.select(getAppSelection);
  }

  download(selection: SelectionState) {
    this.store.dispatch(new SmtExcelExportAction(selection, this.customListService.totalItems));
  }

}
